import i18n from "i18next";
import { GET_BUSINESS_TYPES, ERROR_BUSINESS_TYPES, UNATORIZED } from "./types";

const BusinessTypesReducer = (state, action) => {
    const { payload, type } = action;
    switch (type) {
        case GET_BUSINESS_TYPES:
            return {
                ...state,
                businessTypes: payload,
                isFetching: false,
                error: false,
                message: '',
                tokenError: false
            }
        case ERROR_BUSINESS_TYPES:
            return {
                ...state,
                isFetching: false,
                error: true,
                message: i18n.t('common.error_server'),
            }
        case UNATORIZED:
            return {
                ...state,
                isFetching: false,
                error: true,
                message: i18n.t('common.error_token'),
                tokenError: true
            }
        default:
            return state
    }
}

export default BusinessTypesReducer